import Blazy from 'blazy';

let blazy;
let blazyEager;

/**
 * @returns {Blazy}
 */
export function blazyInstance() {
  if (!blazy) {
    blazy = new Blazy({
      selector: '.js-lazyload',
      successClass: 'is-lazyloaded',
      errorClass: 'has-load-error',
      breakpoints: [
        {
          width: 600, // max-width
          src: 'data-src-small',
        },
        {
          width: 900, // max-width
          src: 'data-src-medium',
        },
      ],
      offset: 400,
    });
  }

  return blazy;
}

/**
 * @returns {Blazy}
 */
export function blazyEagerInstance() {
  if (!blazyEager) {
    blazyEager = new Blazy({
      selector: '.js-lazyload-eager',
      successClass: 'is-lazyloaded',
      errorClass: 'has-load-error',
      loadInvisible: true,
      breakpoints: [
        {
          width: 600, // max-width
          src: 'data-src-small',
        },
        {
          width: 900, // max-width
          src: 'data-src-medium',
        },
      ],
      offset: 400,
    });
  }

  return blazyEager;
}
